import classNames from "classnames";
import EducationIcon from "./Icons/EducationIcon";
import InfoIcon from "./Icons/InfoIcon";
import LevelIcon from "./Icons/LevelIcon";

function HelperButton({ children, onClick, hidden = false }) {
  return (
    <div className="button" onClick={onClick} hidden={hidden}>
      <div className="py-2 py-md-4">{children}</div>
    </div>
  );
}

export default function ExerciseHelperSection({
  equipments = [],
  onChangeLevel,
  onShowEducationalVideo,
  onShowInfo,
  isCompilation = false,
}) {
  const logoColor = "#9B9B9B"; // Default color for icons
  return (
    <div className="exercise-helper-button-grid">
      <div>
        <div className="text-secondary">
          {equipments.map((equipment, index) => (
            <p
              key={index}
              className={classNames({
                "solid-border-bottom": index !== equipments.length - 1,
              })}
            >
              <span className="text-secondary">{equipment}</span>
            </p>
          ))}

          <p className="text-secondary">
            <span className="text-secondary" hidden={equipments.length !== 0}>
              No equipment
            </span>
          </p>
        </div>
      </div>
      <HelperButton onClick={onChangeLevel} hidden={!isCompilation}>
        <LevelIcon fill={logoColor} />
        <p className="mt-md-1 button-text">
          Level &<br />
          Equipment Options
        </p>
      </HelperButton>
      <div hidden={isCompilation}>
        <div className="text-secondary">
          <LevelIcon fill={logoColor} />
          <p className="mt-md-1 button-text">
            No Options
            <br />
            Available
          </p>
        </div>
      </div>
      <HelperButton onClick={onShowEducationalVideo}>
        <EducationIcon fill={logoColor} />
        <p className="mt-md-1 button-text">
          Educational
          <br />
          Video
        </p>
      </HelperButton>
      <HelperButton onClick={onShowInfo}>
        <InfoIcon fill={logoColor} />
        <p className="mt-md-1 button-text">Info</p>
      </HelperButton>
    </div>
  );
}
